<template>
  <div class="content flex my-4">
    <div class="auth-form mx-auto my-auto">
      <div class="card">
        <div class="card-body">
          <h1 class="heading-big mb-3">
            {{ $t('logging.logging') }}
          </h1>
          <f-alert
            v-if="authError"
            theme="danger"
            visible
            class="my-4">
            {{ $t('forgotPassword.errorAuth') }}
          </f-alert>

          <f-alert
            v-if="additionalMessage.length"
            theme="success"
            visible
            centered
            class="mt-3 mb-4"
            v-pure-html="additionalMessage">
          </f-alert>

          <validation-observer
            ref="login-form"
            tag="form">
            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }">
              <div class="form-group">
                <label>{{ $t('user.emailAddress') }}</label>
                <f-input
                  v-model="email"
                  name="email"
                  type="email"
                  class="full-width"
                  :state="errors.length ? 'invalid' : null"
                  :placeholder="$t('resetPassword.yourEmail')" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <validation-provider
              rules="required"
              name="password"
              v-slot="{ errors }">
              <div class="form-group">
                <label class="flex">
                  {{ $t('user.password') }}
                  <router-link
                    tabindex="5"
                    to="/odzyskaj-haslo"
                    class="lnk ml-auto"
                    :disabled="submitting">
                    {{ $t('logging.forgotPassword') }}
                  </router-link>
                </label>
                <f-input
                  v-model="password"
                  name="password"
                  type="password"
                  autocomplete="off"
                  class="full-width"
                  :state="errors.length ? 'invalid' : null"
                  :placeholder="$t('resetPassword.yourPassword')" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <f-button
              type="submit"
              theme="primary"
              class="full-width mt-1"
              big
              withArrow
              @click.prevent="validateForm"
              :disabled="submitting">
              <template v-if="!submitting">{{ $t('logging.login') }}</template>
              <template v-else>{{ $t('logging.logging') }}&hellip;</template>
            </f-button>
          </validation-observer>

          <div class="flex flex-column text-center mt-4">
            <router-link
              to="/rejestracja"
              class="lnk lnk-big lnk-big-blue mb-2"
              :disabled="submitting">
              {{ $t('register.register') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import AppConfig from './../.env.js';
import FormUtils from '@/utils/FormUtils.js';
import SanitizeUtils from '@/utils/SanitizeUtils';

export default {
  name: 'Login',
  computed: {
    additionalMessage () {
      if (this.$route.params.message === 'konto-aktywne') {
        return this.$t('logging.yourAccountActiveNow');
      }
      if (this.$route.params.message === 'haslo-zmienione') {
        return this.$t('logging.yourPasswordChangeLogIn');
      }
      if (this.$route.params.message === 'udana-rejestracja') {
        return this.$t('logging.registrationEndYouCanLogIn');
      }

      return '';
    }
  },
  data () {
    return {
      authError: false,
      submitting: false,
      email: '',
      password: ''
    }
  },
  mounted () {
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['login-form'], this.login);
    },
    login () {
      this.authError = false;
      this.submitting = true;
      delete this.$http.defaults.headers['X-Csrf-Token'];

      this.$http.post('/api/auth/login', {
        email: this.email,
        password: this.password
      }).then((response) => {
        this.submitting = false;
        this.$http.defaults.headers['X-Csrf-Token'] = `${response.data.csrf_token}`;
        this.$store.commit('setUserID', response.data.id);
        this.$store.commit('setUserEmail', response.data.email);
        this.$store.commit('setUserType', response.data.type);
        this.$store.commit('setUserPermissions', response.data.permissions);

        if (response.data.type === 'ADVISER') {
          this.$store.commit('setUserAccountValidTo', response.data.account_valid_to);
          this.$store.commit('setUserHasValidAccount', response.data.has_valid_account);
          this.$store.commit('setUserPackage', response.data.package);
        }
        window.localStorage.setItem('last-token-refresh', +new Date());

        if (AppConfig.isMobileApp) {
          window.localStorage.setItem('fincrm-app-token', response.data.token);
          Vue.prototype.$http.defaults.headers.Authorization = 'Bearer ' + SanitizeUtils.getToken();
        }

        this.$bus.$emit('user-logged-in');

        Vue.nextTick(() => {
          if (response.data.permissions.settlements && !response.data.package) {
            this.$router.push('/rozliczenia');
            return;
          }
          this.$router.push('/pulpit');
        });
      }).catch((error) => {
        this.$bus.$emit('user-logged-out', true);
        console.log(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>
